import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext, useEffect, useState } from "react"
import { Building, BuildingFillCheck, Check2Square, FileEarmarkPerson, PersonLinesFill, PersonPlusFill, PersonXFill, XSquare } from "react-bootstrap-icons"
import ConfirmDialog from "../../../../../components/dialogs/ConfirmDialog"
import Authentication from "../../../../../libs/api/services/Authentication"
import Facility from "../../../../../libs/api/services/Facility"
import User from "../../../../../libs/api/services/User"
import { UserManagementContext } from "../UserManagementScreen"

export const FacilitiesSection = () => {
    const { state, setUser } = useContext(UserManagementContext)
    const [facilites, setFacilities] = useState([])

    useEffect(() => {
        if (state && state.roles && state.roles.facilities) {
            setFacilities(state.roles.facilities)
        }
    }, [])

    const _handleSearch = (s) => {
        if (s === "")
            setFacilities(state.roles.facilities)
        else
            setFacilities(state.roles.facilities.filter(x => x.facility.toLowerCase().includes(s.toLowerCase())))
    }

    return <div>
        <h3 className='text-center d-flex'><div className='flex-grow-1'>Facilities And Roles</div>
            {Authentication.isClaimValid("System Admin") && <div><SuperPermissionToggle user={state.user} /></div>}
        </h3>
        <div className="px-2">
            <input onChange={(e) => _handleSearch(e.target.value)} className="form-control" placeholder="Filter" />
        </div>
        {facilites.map((f) => <FacilitiesFacilitySection facility={f} />)}
    </div>
}
const FacilitiesFacilitySection = ({ facility }) => {
    const [expended, setExpanded] = useState(false)
    const { state } = useContext(UserManagementContext)

    const fltrRole = () => {
        try {
            return state.roles.activeRoles.filter(s => s.facility && s.facility.id === parseInt(facility.id))
        } catch (r) {
            return []
        }
    }

    return (<ul className='list-unstyled ms-3' style={{ fontSize: '125%' }}>
        <li onClick={() => setExpanded(!expended)}>
            {fltrRole().length > 0 ? <BuildingFillCheck /> : <Building />}
            {facility.facility}</li>
        <li>
            <ul className={`list-unstyled mx-3 ${expended ? '' : 'd-none'}`}>
                <FacilitiesAssignNewRoleSection facility={facility} activeRoles={state.roles.activeRoles} />
                {fltrRole().map((m) => <FacilitiesActiveRoleSection role={m} />)}
            </ul>
        </li>
    </ul>)
}
const FacilitiesActiveRoleSection = ({ role }) => {
    const { allocRevokeRole } = useContext(UserManagementContext)
    const [confirmDetails, setConfirmDetails] = useState({ onCancel: () => { }, onConfirm: () => { }, title: '', heading: '', open: false })

    const _handleRevoke = () => {
        setConfirmDetails({
            ...confirmDetails, open: true,
            onConfirm: () => allocRevokeRole(role),
            onCancel: () => setConfirmDetails({ ...confirmDetails, open: false })
        })
    }
    return (<>
        <ConfirmDialog {...confirmDetails}>
            Are you sure you would like to revoke the {role.roles.preferedName} role from this user?
        </ConfirmDialog>
        <li className="d-flex justify-content-between"><div><PersonLinesFill /> {role.roles.preferedName}</div><div>
            <button className="btn p-0 m-0" onClick={() => _handleRevoke()}>
                <PersonXFill size={'20'} />
            </button>
        </div></li>
    </>)
}

const FacilitiesAssignNewRoleSection = ({ facility, activeRoles }) => {
    const { allocRole, state } = useContext(UserManagementContext)
    const [expended, setExpanded] = useState(false)
    const [roles, setRoles] = useState()

    useEffect(() => {
        const load = async () => {
            var roles = await Facility.roles()
            setRoles(
                roles.filter(a =>
                    !activeRoles.filter(x => x.facility.id === facility.id).map(r => r.roles.id).includes(a.id)
                )
            )
        }
        load()
    }, [state.roles])
    return (<><li onClick={() => setExpanded(!expended)}><FileEarmarkPerson /> Assign a new role</li>
        <li>
            <ul className={`list-unstyled ms-3 ${expended ? '' : 'd-none'}`}>
                {roles && roles.map((r) => <li onClick={() => allocRole(facility, r)}><PersonPlusFill /> {r.role}</li>)}
            </ul>
        </li></>)
}

const SuperPermissionToggle = ({ user }) => {
    const [isActive, setActive] = useState(user.userRoles.find(x => x.role === "System Admin"))
    const [loading, setLoading] = useState(false)
    const _handleSetSysAdmin = () => {
        setLoading(true)
        User.addPermissions(user.id, { id: 1, role: "System Admin" })
            .then((r) => { setActive(!isActive); setLoading(false) })
    }


    return (loading ? <div className='mx-3 w-25 text-center'><FontAwesomeIcon icon={faSpinner} spin /></div> : <button className='btn' onClick={() => _handleSetSysAdmin()}>
        {isActive ? <Check2Square className='me-2' /> : <XSquare className='me-2' />}
        System Admin</button>)
}